import React from "react"
import { LoginFormData, RegistrationFormData } from "./types"

export interface AuthenticationContents {
  login: LoginFormData
  register: RegistrationFormData
}

export const AuthContentsContext = React.createContext<AuthenticationContents>({
  login: {
    forgotPwdLinkDescription: "Hai dimenticato la password?",
    forgotPwdLinkName: "Reset",
    form: {
      emailLoginCta: "Accedi",
      facebookLoginCta: "Accedi con Facebook",
      googleLoginCta: "Accedi con Google",
      passwordLabel: "Password",
      socialAndEmailLoginSeparator: "oppure",
      usernameLabel: "Email",
    },
    messages: {
      genericError: "Ops, si è verificato un errore",
      wrongCredentials: "Credenziali non valide",
    },
    registrationLinkDescription: "Non hai ancora un account?",
    registrationLinkName: "Registrati",
    subtitle: "",
    title: "Accedi",
  },
  register: {
    form: {
      birthdayLabel: "Data di nascita",
      emailLabel: "Email",
      facebookRegistrationCta: "Registrati con Facebook",
      firstNameLabel: "Nome",
      googleRegistrationCta: "Registrati con Google",
      lastNameLabel: "Cognome",
      passwordLabel: "Password",
      registerCta: "Registrati",
      socialAndEmailLoginSeparator: "oppure",
    },
    loginLinkDescription: "Hai già un account?",
    loginLinkName: "accedi",
    messages: {
      emailAlreadyRegistered: "Utente già registrato",
      genericError: "Ops, si è verificato un errore",
      registrationSuccess:
        "Per completare la registrazione controlla la tua mail e completa la verifica",
    },
    subtitle: "",
    title: "Registrati",
  },
})

export const useAuthContents = () => React.useContext(AuthContentsContext)
